export type ProductMaster = {
    id: string,
    categoryMasterId: string,
    taxCategoryMasterId: string,
    code: string,
    name: string,
    nonTaxPrice: number,
    taxPrice: number,
    includeTaxPrice: number,
    inventory: number,
    InventoryExceedSize: number,
    limitSpan: string,
    startLimit: Date,
    endLimit: Date,
    isDelivery: boolean,
    deriverySpan: number,
    noInventoryDeliverySpan: number,
    biko: string,
    explanation: string,
    invalidFlg: boolean,
    createTime: Date,
    updateTime: Date,
    deleteFlg: boolean,
    deleteTime: Date,
}

export type ResponseParamBase = {
    message: string,
    resultFlg: boolean,
}

export const PaymentPageType = {
    New: 1,
    Continue: 2,
    Pccase: 3,
} as const

type PaymentPageType = typeof PaymentPageType[keyof typeof PaymentPageType];

/**
 * Newlicense�y�[�W�ɑ΂��ēn���p�����[�^
 * */
export type NewProductParam = {
    categoryCode: string,
    productCode: string,
    lisenceKey: string,
    paymentPageType: PaymentPageType,
}

//Paymentconfirm�y�[�W�ɑ΂��ēn���p�����[�^
export type BuyProductParam = {
    productName: string,
    quantity: number,
    categoryCode: string,
    productCode: string,
    nonTaxPrice: number,
    taxPrice: number,
    includeTaxPrice: number,
    postCode: string,
    address: string,
    customerName: string,
    phoneNumber: string,
    biko: string,
    isDelivery: boolean,    
    paymentPageType: PaymentPageType,
}
/**
 * Paymentconfirm��ʂŎg�p�B�w���\��̏��i�f�[�^�B
 * */
export type UserLicenses = {
    productId: string,
    quantity: number,
    licenseKey: string,
    startLimit: Date,
    endLimit: Date,
    nonTaxPrice: number,
    taxPrice: number,
    includeTaxPrice: number,
    totalNonTaxPrice: number,
    totalTaxPrice: number,
    totalIncludeTaxPrice: number,
    displayNonTaxPrice: string,
    displayTaxPrice: string,
    displayIncludeTaxPrice: string,
    displayTotalNonTaxPrice: string,
    displayTotalTaxPrice: string,
    displayTotalIncludeTaxPrice: string,
    limitSpanStartStr: string,
    limitSpanEndStr: string,
    limitSpanStr: string,
    isLValidLimit: boolean,
    isTrial: boolean,
}

/**
 * �p�����C�Z���X��ʂŎg�p�B�p�����C�Z���X�̃f�[�^�B
 * */
export type ContinueLicenses = UserLicenses & {
    userLicenseId: string,
    isLValidOverOneYear: boolean,
    isChecked: string[],
}

/**
 * UserLicenses�̔z��Ƃ��̍��v���z
 * */
export type LicenseDatas = {
    userLicenses: ContinueLicenses[],
    totalIncludeTaxPrice: number,
    totalTaxPrice: number,
    totalNonTaxPrice: number,
    displayTotalIncludeTaxPrice: number,
    displayTotalTaxPrice: number,
    displayTotalNonTaxPrice: number,
}

/**
 * PaymentConfirm�y�[�W�ɑ΂��ēn���p�����[�^
 * */
export type ToPaymentConfirm = {
    productParam: BuyProductParam,
    purchaseParam: LicenseDatas,
    deliverySpan: number,
    test: string,
}

//�w�����ɃT�[�o�ɓn���p�����[�^
export type PurchaseParamRows = {

}
export type PurchaseParam = {

}

/**
 * �̎�����ʂ̃��X�g�̍s
 * */
export type ReceiptListRow = {
    purchaseHistoryId: string,
    aspNetUsersId: string,
    productMasterId: string,
    purchaseDateStr: string,
    productName: string,
    quantity: number,
    includeTaxPrice: number,
    atena: string,
    isIssue: boolean,
    isLValidOverOneYear: boolean,
    displayIncludeTaxPrice: string,
}

/**
 * �̎�����ʂ̈����ύX���̃��N�G�X�g�p�����[�^
 * */
export type UserManager_DownloadReceiptFile_Request = {
    purchaseHistoryId: string,
    atena: string,
    isUpdateAtena: boolean,
}

/**
 * �̎�����ʂ̈����ύX���̃��X�|���X�p�����[�^
 * */
export type UserManager_ChangeReciptAtena_Response = {
    count: number,
}